"use strict";

exports.__esModule = !0, exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base")),
    _react = _interopRequireDefault(require("react")),
    _constants = require("../constants");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var DropdownHandle = function DropdownHandle(a) {
  var b = a.props,
      c = a.state,
      d = a.methods;
  return /*#__PURE__*/_react.default.createElement(DropdownHandleComponent, {
    tabIndex: "-1",
    onClick: function onClick(a) {
      return d.dropDown(c.dropdown ? "close" : "open", a);
    },
    dropdownOpen: c.dropdown,
    onKeyPress: function onKeyPress(a) {
      return d.dropDown("toggle", a);
    },
    onKeyDown: function onKeyDown(a) {
      return d.dropDown("toggle", a);
    },
    className: _constants.LIB_NAME + "-dropdown-handle",
    rotate: b.dropdownHandleRenderer ? 0 : 1,
    color: b.color
  }, b.dropdownHandleRenderer ? b.dropdownHandleRenderer({
    props: b,
    state: c,
    methods: d
  }) : /*#__PURE__*/_react.default.createElement("svg", {
    fill: "currentColor",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 26.4q0 .3-.2.5l-1.1 1.2q-.3.2-.6.2t-.5-.2l-8.7-8.8-8.8 8.8q-.2.2-.5.2t-.5-.2l-1.2-1.2q-.2-.2-.2-.5t.2-.5l10.4-10.4q.3-.2.6-.2t.5.2l10.4 10.4q.2.2.2.5z"
  })));
},
    DropdownHandleComponent = (0, _styledBase.default)("div", {
  target: "e1vudypg0",
  label: "DropdownHandleComponent"
})("text-align:center;", function (a) {
  var b = a.dropdownOpen,
      c = a.rotate;
  return b ? "\n      pointer-events: all;\n      " + (c ? "transform: rotate(0deg);margin: 0px 0 -3px 5px;" : "") + "\n      " : "\n      pointer-events: none;\n      " + (c ? "margin: 0 0 0 5px;transform: rotate(180deg);" : "") + "\n      ";
}, ";cursor:pointer;svg{width:16px;height:16px;}:hover{path{stroke:", function (a) {
  var b = a.color;
  return b;
}, ";}}:focus{outline:none;path{stroke:", function (a) {
  var b = a.color;
  return b;
}, ";}}" + ("production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0Ryb3Bkb3duSGFuZGxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCMEMiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvRHJvcGRvd25IYW5kbGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgTElCX05BTUUgfSBmcm9tICcuLi9jb25zdGFudHMnO1xuXG5jb25zdCBEcm9wZG93bkhhbmRsZSA9ICh7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcyB9KSA9PiAoXG4gIDxEcm9wZG93bkhhbmRsZUNvbXBvbmVudFxuICAgIHRhYkluZGV4PVwiLTFcIlxuICAgIG9uQ2xpY2s9eyhldmVudCkgPT4gbWV0aG9kcy5kcm9wRG93bihzdGF0ZS5kcm9wZG93biA/ICdjbG9zZScgOiAnb3BlbicsIGV2ZW50KX1cbiAgICBkcm9wZG93bk9wZW49e3N0YXRlLmRyb3Bkb3dufVxuICAgIG9uS2V5UHJlc3M9eyhldmVudCkgPT4gbWV0aG9kcy5kcm9wRG93bigndG9nZ2xlJywgZXZlbnQpfVxuICAgIG9uS2V5RG93bj17KGV2ZW50KSA9PiBtZXRob2RzLmRyb3BEb3duKCd0b2dnbGUnLCBldmVudCl9XG4gICAgY2xhc3NOYW1lPXtgJHtMSUJfTkFNRX0tZHJvcGRvd24taGFuZGxlYH1cbiAgICByb3RhdGU9e3Byb3BzLmRyb3Bkb3duSGFuZGxlUmVuZGVyZXIgPyAwIDogMX1cbiAgICBjb2xvcj17cHJvcHMuY29sb3J9PlxuICAgIHtwcm9wcy5kcm9wZG93bkhhbmRsZVJlbmRlcmVyID8gKFxuICAgICAgcHJvcHMuZHJvcGRvd25IYW5kbGVSZW5kZXJlcih7IHByb3BzLCBzdGF0ZSwgbWV0aG9kcyB9KVxuICAgICkgOiAoXG4gICAgICA8c3ZnIGZpbGw9XCJjdXJyZW50Q29sb3JcIiB2aWV3Qm94PVwiMCAwIDQwIDQwXCI+XG4gICAgICAgIDxwYXRoIGQ9XCJNMzEgMjYuNHEwIC4zLS4yLjVsLTEuMSAxLjJxLS4zLjItLjYuMnQtLjUtLjJsLTguNy04LjgtOC44IDguOHEtLjIuMi0uNS4ydC0uNS0uMmwtMS4yLTEuMnEtLjItLjItLjItLjV0LjItLjVsMTAuNC0xMC40cS4zLS4yLjYtLjJ0LjUuMmwxMC40IDEwLjRxLjIuMi4yLjV6XCIgLz5cbiAgICAgIDwvc3ZnPlxuICAgICl9XG4gIDwvRHJvcGRvd25IYW5kbGVDb21wb25lbnQ+XG4pO1xuXG5jb25zdCBEcm9wZG93bkhhbmRsZUNvbXBvbmVudCA9IHN0eWxlZC5kaXZgXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgJHsoeyBkcm9wZG93bk9wZW4sIHJvdGF0ZSB9KSA9PlxuICAgIGRyb3Bkb3duT3BlblxuICAgICAgPyBgXG4gICAgICBwb2ludGVyLWV2ZW50czogYWxsO1xuICAgICAgJHtyb3RhdGUgPyAndHJhbnNmb3JtOiByb3RhdGUoMGRlZyk7bWFyZ2luOiAwcHggMCAtM3B4IDVweDsnIDogJyd9XG4gICAgICBgXG4gICAgICA6IGBcbiAgICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgICAgJHtyb3RhdGUgPyAnbWFyZ2luOiAwIDAgMCA1cHg7dHJhbnNmb3JtOiByb3RhdGUoMTgwZGVnKTsnIDogJyd9XG4gICAgICBgfTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gIHN2ZyB7XG4gICAgd2lkdGg6IDE2cHg7XG4gICAgaGVpZ2h0OiAxNnB4O1xuICB9XG5cbiAgOmhvdmVyIHtcbiAgICBwYXRoIHtcbiAgICAgIHN0cm9rZTogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG4gICAgfVxuICB9XG5cbiAgOmZvY3VzIHtcbiAgICBvdXRsaW5lOiBub25lO1xuXG4gICAgcGF0aCB7XG4gICAgICBzdHJva2U6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuICAgIH1cbiAgfVxuYDtcblxuZXhwb3J0IGRlZmF1bHQgRHJvcGRvd25IYW5kbGU7XG4iXX0= */")),
    _default = DropdownHandle;

exports.default = _default;